<template>
  <a
    v-if="file"
    class="download"
    :class="type"
    :href="fileUrl"
    target="_blank"
    download
  >
    <Icon :icon="'download'" />
    <div class="download__text">Download datasheet ({{ fileFormat }})</div>
  </a>
</template>

<script>
import config from "../../nuxt.config";

export default {
  name: "Download",
  components: {
    Icon: () => import("../elements/Icon"),
  },
  props: {
    file: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    fileUrl() {
      let url = "";
      if (this.file) {
        const startStr = this.file.substring(0, 4);
        if (startStr !== "http") {
          url = config.env.BASE_URL + this.file;
        } else {
          url = this.file;
        }
      }
      return url;
    },
    fileFormat() {
      return this.file ? this.file.slice(-4).toUpperCase() : "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.download {
  display: flex;
  align-items: center;
  color: $red;
  font-size: 1.2rem;
  font-weight: 600;
  text-decoration: none;
  margin-left: 1rem;

  img {
    margin-right: 0.6rem;
  }
  &:hover {
    text-decoration: underline;
  }

  &.no-margin {
    margin-left: 0;
    margin-bottom: 2rem;
  }
}
</style>
